const en = {
    all: 'All',
    allowed: 'Allowed',
    already_have_account: 'Already have an account?',
    and: 'and',
    back: 'back',
    cancel: 'Cancel',
    by_registering_agree: 'By registering, I agree to CodeAcademy Online',
    change_password: 'change password',
    code: 'Code',
    code_required: 'Code is required',
    create_group: 'Create group',
    created_groups: 'Created groups',
    confirm_new_password: 'Confirm New Password',
    content: 'Content',
    course_code: 'Course code',
    course_illustration: 'Course illustration',
    courses: 'Courses',
    dashboard: 'Dashboard',
    didnt_receive_email: 'Didn’t receive an email?',
    dont_have_account: `Don’t have an account?`,
    edit: 'Edit',
    email_address: 'Email address',
    email_address_must_be_from_codeacademy_domain: 'Must be a valid CodeAcademy email',
    email_address_must_be_valid: 'Email must be a valid email address',
    email_address_required: 'Email address is required',
    enter_new_password_subtitle: 'Please enter your new password that will be associated with your account.',
    enter_new_password_title: 'Enter your new password',
    error_fetching_courses: 'Something went wrong fetching the courses.',
    error_fetching_lessons: 'Something went wrong fetching the lessons.',
    error_fetching_modules: 'Something went wrong fetching the modules.',
    error_fetching_topic_content: 'Something went wrong fetching the topic content.',
    error_fetching_topics: 'Something went wrong fetching the topics.',
    evening: 'Evening',
    finish: 'Finish',
    first_name: 'First name',
    first_name_required: 'First name is required',
    forgot_password: 'Forgot password',
    forgot_your_password_details:
        'Please enter the email address associated with your account and we will email you a link to reset ' +
        'your password.',
    forgot_your_password_title: 'Forgot your password?',
    hours: 'hours',
    general: 'general',
    go_to_home: 'Go to Home',
    group: 'Group',
    group_content: 'Group Content',
    groups: 'Groups',
    manage_group_content: 'Manage group content',
    manage_groups: 'Manage groups',
    manage_roles: 'Manage roles',
    activity_log: 'Activity log',
    activity_log_hint:
        'Who created, changed or deleted groups, students, roles and meetings, or sent emails, and when. Recorded since the log was switched on; failed actions are marked.',
    activity_log_search: 'Search by group or name',
    activity_log_person: 'Done by',
    activity_log_no_people: 'No such person',
    activity_log_action: 'Action',
    activity_log_all_actions: 'All actions',
    activity_log_failed_only: 'Failed only',
    activity_log_refresh: 'Refresh',
    activity_log_empty: 'No entries.',
    activity_log_load_more: 'Show older',
    activity_log_failed: 'Failed',
    activity_log_students_count: 'Students: {{count}}',
    activity_log_role: 'Role: {{role}}',
    activity_action_group_created: 'Group created',
    activity_action_group_updated: 'Group edited',
    activity_action_group_deleted: 'Group deleted',
    activity_action_meeting_scheduled: 'Meeting scheduled',
    activity_action_meeting_deleted: 'Meeting deleted',
    activity_action_teams_synced: 'Synced with Teams',
    activity_action_staff_notified: 'Email sent to a lecturer or curator',
    activity_action_lecturers_assigned: 'Lecturers assigned',
    activity_action_curator_assigned: 'Curator assigned',
    activity_action_students_added: 'Existing students added',
    activity_action_statuses_verified: 'Student statuses checked',
    activity_action_student_created: 'Student created',
    activity_action_student_updated: 'Student edited',
    activity_action_student_deleted: 'Student deleted',
    activity_action_student_groups_changed: 'Student groups changed',
    activity_action_role_assigned: 'Role given',
    activity_action_role_removed: 'Role removed',
    activity_action_role_reassigned: 'Role changed',
    activity_action_onboarding_emails_run: 'Email sending run',
    activity_action_onboarding_email_sent: 'Welcome email sent',
    manage_users: 'Manage users',
    assign_lecturer: 'Assign lecturer',
    select_lecturer: 'Select lecturer',
    assign_curator: 'Assign curator',
    select_curator: 'Select curator',
    assign_courses: 'Assign courses',
    assign_groups: 'Assign groups',
    assign_role: 'Assign role',
    current_roles: 'Current roles',
    role: 'Role',
    curator: 'Curator',
    role_assigned_successfully: 'Role assigned successfully',
    user_not_found_for_role_assignment: 'User was not found. Only existing users can be assigned a role.',
    multiple_users_found_provide_email:
        'More than one user with this name was found. Please provide email to select the correct user.',
    email_optional_for_role_assignment: 'Optional. Required only if multiple users share same name and surname.',
    role_assign_only_existing_users:
        'Only users that already exist in the system can be assigned a role. Email is optional, but required ' +
        'when multiple users have the same name and surname.',
    remove_role_confirmation: 'Do you want to remove role {{role}} from user {{user}}?',
    groups_content: "group's content",
    groups_content_updates: `Group's content updated`,
    admin: 'Admin',
    docs: 'Documentation',
    docs_subtitle: 'How to use Code Academy Online: only the pages for your role are shown.',
    docs_search: 'Search the documentation',
    docs_no_results: 'Nothing found. Try another word.',
    docs_on_this_page: 'On this page',
    docs_not_found: 'This documentation page does not exist or is not available to you.',
    docs_back: 'Back to documentation',
    docs_group_start: 'Getting started',
    docs_group_learning: 'Learning',
    docs_group_chat: 'Code Academy AI',
    docs_group_teaching: 'For lecturers',
    docs_group_admin: 'Administration',
    docs_group_superadmin: 'For super admins',
    chat_insights: 'Chatbot Insights',
    chat_insights_subtitle: 'Usage and quality numbers for Code Academy AI — visible to super-admins only.',
    chat_insights_tab_overview: 'Overview',
    chat_insights_tab_topics: 'Topics',
    chat_insights_distinct_users: 'Distinct people (all time)',
    chat_insights_distinct_users_today: 'Distinct people today',
    chat_insights_messages_today: 'Messages today',
    chat_insights_rate_limited_today: 'Hit today’s limit',
    chat_insights_total_conversations: 'Total conversations',
    chat_insights_total_messages: 'Total messages',
    chat_insights_refusal_rate: '"Not covered" rate',
    chat_insights_daily_breakdown: 'Daily activity',
    // Deliberately not "...today"/"...(all time)" — those labels belong to the
    // stat cards above, which really are today/all-time numbers. This chart
    // plots one value per historical date, so a per-series name needs to read
    // correctly for every date on the X axis, not just today's.
    chat_insights_chart_messages: 'Messages',
    chat_insights_chart_distinct_users: 'Distinct people',
    chat_insights_top_topics: 'What people are asking about (in period)',
    chat_insights_top_topics_chart_label: 'Replies',
    chat_insights_range: 'Date range',
    chat_insights_last_n_days: 'Last {{count}} days',
    chat_insights_data_from: 'Data shown from',
    chat_insights_no_data_yet: 'No data for this range yet.',
    chat_insights_notes: 'Tester notes',
    chat_insights_notes_hint: 'Chat messages that start with the word "pastaba". The newest 200 are shown.',
    chat_insights_notes_empty: 'No notes yet.',
    chat_insights_notes_question: 'Question',
    chat_insights_notes_answer: 'Answer',
    chat_insights_notes_local: 'local',
    chat_insights_positive_ratings: 'Thumbs up',
    chat_insights_negative_ratings: 'Thumbs down',
    chat_insights_web_answers: 'Official documentation answers',
    chat_insights_locked_topics: 'Questions about lessons not yet open',
    chat_insights_section_usage: 'Usage',
    chat_insights_section_period: 'In the selected period',
    chat_insights_answers: 'Replies',
    chat_insights_handoffs: 'Help requests',
    chat_insights_handoffs_hint:
        'Users who pressed "Talk to a person". Contact them by email and mark the request resolved.',
    chat_insights_handoffs_empty: 'No requests yet.',
    chat_insights_handoff_open: 'Open',
    chat_insights_handoff_resolved: 'Resolved',
    chat_insights_handoff_mark_resolved: 'Mark resolved',
    chat_insights_handoff_reopen: 'Reopen',
    chat_insights_handoff_transcript: 'Show conversation',
    chat_insights_handoff_transcript_expired:
        'The conversation is no longer available: 30 days have passed or it was never saved.',
    chat_insights_handoff_summary: 'Summary',
    chat_insights_handoff_no_summary: 'No summary.',
    chat_insights_transcript_audit_note: 'Opening a conversation is recorded in the access log.',
    chat_insights_close: 'Close',
    chat_insights_gaps: 'Content gaps',
    chat_insights_gaps_hint:
        'Questions from the last 7 days that the material did not answer or that were rated down, grouped by topic.',
    chat_insights_gaps_generate: 'Build report',
    chat_insights_gaps_counts: 'Questions: {{total}} (not answered: {{refused}}, rated down: {{negative}})',
    chat_insights_gaps_empty: 'No gaps found for this period.',
    chat_insights_audit: 'Access log',
    chat_insights_audit_hint: 'Who viewed conversation content, and when.',
    chat_insights_audit_empty: 'No entries yet.',
    chat_insights_audit_action_notes: 'Notes list',
    chat_insights_audit_action_handoffs: 'Help request list',
    chat_insights_audit_action_transcript: 'Conversation view',
    chat_insights_audit_action_gaps: 'Content gap report',
    chat_insights_refresh: 'Refresh',
    home: 'Home',
    incorrect_or_tampered_link: 'Incorrect or tampered link',
    internal_server_error: 'Internal Server Error',
    internal_server_error_description:
        'There was an error. Please try again later or contact your system administrator.',
    last_name: 'Last name',
    last_name_required: 'Last name is required',
    latest: 'Latest',
    lesson: 'Lesson',
    lessons: 'Lessons',
    link_to_login_text: 'Login',
    link_to_registration_text: 'Get started',
    login: `Login`,
    login_form_subtitle: `Enter your credentials below.`,
    login_form_title: 'Sign in to CodeAcademy Online',
    login_greeting_title: 'Welcome Back!',
    login_illustration: 'login illustration',
    login_with_google: `Login with Google`,
    logout: `Logout`,
    module_code: 'Module code',
    module_illustration: 'module illustration',
    modules: 'Modules',
    morning: 'Morning',
    name: 'Name',
    new_password: 'New Password',
    new_password_helper_text: 'Password must be minimum 8+',
    new_password_required: 'New password is required',
    next: 'Next',
    no_modules_for_this_group: 'No modules assigned for this group.',
    no_courses_found: 'No courses found',
    no_lessons_found: 'No lessons found',
    no_modules_found: 'No modules found',
    no_results_for: 'No results found for',
    no_results_helper_text: 'Try checking for typos or using complete words.',
    no_topics_found: 'No topics found',
    not_found: 'Not found',
    notifications: 'notifications',
    old_password: 'Old Password',
    old_password_required: 'Old Password is required',
    owners: 'Owners',
    open_lessons_helper_text: 'Empty value means module is not visible',
    opened_lessons: 'Opened lessons',
    open: 'Open',
    page_not_found: 'Page Not Found',
    page_not_found_description:
        'Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to ' +
        'check your spelling.',
    password: 'Password',
    password_must_be_at_least_8_characters: 'Password must be at least 8 characters',
    password_must_match: 'Passwords must match',
    password_required: 'Password is required',
    please_check_your_email: 'Please check your email.',
    please_try_again_or_contact_admin:
        'Please try again later or contact your system administrator if the issue persists.',
    privacy_policy: 'Privacy Policy',
    redirecting: 'Redirecting',
    register: `Register`,
    register_illustration: 'register illustration',
    registration_form_subtitle: `Exclusively dedicated to the students of CodeAcademy and CodeAcademy College.`,
    registration_form_title: 'Join CodeAcademy Online',
    registration_greeting_title: `An online education platform to support our students`,
    remember_me: 'Remember me',
    confirm_email: 'Confirm your email address',
    resend_email: 'Resend email',
    reset_password: 'Reset Password',
    reset_password_greeting_title: 'Get back on track and continue learning',
    reset_password_illustration: 'reset password illustration',
    save_changes: 'Save Changes',
    search_groups: 'Search groups',
    search_by_name_or_code: 'Search by name or code',
    search_by_name: 'Search by name or surname',
    sent_confirmation_email_to: 'We have sent a confirmation email to',
    set_password: 'Set Password',
    something_went_wrong: 'Something went wrong.',
    add_existing_student: 'Add existing',
    verify_provisioning: 'Check status',
    status_fields_updated: 'Fields updated',
    status_drift_found: 'Mismatches found',
    status_unverifiable: 'Could not be verified',
    status_already_up_to_date: 'Everything already matches',
    teams_check_unavailable: 'Teams membership could not be checked',
    meeting_check_unavailable: 'Meeting invitation could not be checked',
    ms_provisioning_disabled: 'Microsoft provisioning is disabled by configuration.',
    students_enrolled: 'Students added to the group',
    students_skipped: 'Students skipped',
    existing_student_move_hint: 'Selected students are moved to this group and removed from their previous one.',
    forbidden_access: 'You do not have permission to perform this action.',
    staff_user_not_found: 'The selected user was not found.',
    user_does_not_hold_required_role: 'The selected user does not have the required role.',
    no_students_enrolled: 'No students could be added.',
    too_many_students_per_request: 'Select at most 50 students at a time.',
    chat_title: 'Code Academy AI',
    chat_intro_header: 'Before you start',
    chat_intro_title: 'About Code Academy AI',
    chat_intro_body_1:
        'Code Academy AI answers questions using your course material — the lectures, notes, and topics you ' +
        'have access to.',
    chat_intro_body_2:
        "It only answers from that material. If something isn't covered, it'll tell you rather than guess.",
    chat_intro_body_3:
        'It replies in the language the site is shown in. Conversations are kept on the Code Academy server ' +
        'for 30 days, so you can continue them on another device.',
    chat_consent_label:
        'I agree that my messages are sent to an AI service to generate a reply, ' +
        'and kept on the Code Academy server for 30 days so I can continue my conversations later.',
    chat_intro_continue: 'Continue',
    chat_greeting: 'Hi! How can I help?',
    chat_scope_title: 'You can ask about:',
    chat_scope_toggle: 'Topics',
    chat_code_copy: 'Copy code',
    chat_code_copied: 'Copied',
    chat_quota_left_one: 'You have {{n}} message left today',
    chat_quota_left_few: 'You have {{n}} messages left today',
    chat_quota_left_many: 'You have {{n}} messages left today',
    chat_quota_used_up: "You've used today's messages. They renew tomorrow.",
    chat_scope_module_question: 'What topics does the “{module}” module cover?',
    chat_rate_limited: "You've reached today's message limit. Try again tomorrow.",
    chat_session_conflict: 'This chat needs to restart — please send your message again.',
    chat_not_in_pilot: 'This assistant isn’t available to your group yet.',
    chat_placeholder: 'Type your message…',
    chat_typing: 'Typing…',
    chat_searching_docs: 'Searching the official documentation…',
    chat_new_conversation: 'New chat',
    chat_history: 'Chat history',
    chat_back_to_conversation: 'Back to chat',
    chat_untitled: 'New conversation',
    chat_delete_title: 'Remove this chat?',
    chat_delete_body: 'This deletes the conversation from this device and from the Code Academy server.',
    chat_delete_confirm: 'Remove',
    chat_select_all: 'Select all',
    chat_delete_selected: 'Delete selected',
    chat_delete_many_title: 'Delete the selected conversations ({{n}})?',
    chat_delete_many_body: 'The conversations will be deleted from this device and from the Code Academy server.',
    chat_delete_server_failed: 'The conversation could not be deleted from the server. Please try again later.',
    chat_history_loading: 'Loading the conversation',
    chat_empty_hint: 'Start a new chat to begin.',
    chat_consent_required: 'Please confirm your consent to continue.',
    chat_rate_up: 'Helpful answer',
    chat_rate_down: 'Not helpful',
    chat_handoff_open: 'Talk to a person',
    chat_handoff_title: 'Pass your question to the team',
    chat_handoff_body: 'The Code Academy team will get a short summary of this chat and contact you by email.',
    chat_handoff_comment: 'Anything to add? (optional)',
    chat_handoff_send: 'Send',
    chat_handoff_sent: 'Request sent. The team will contact you.',
    chat_handoff_limit: "You've sent a lot of requests today. Try again tomorrow.",
    sorted_ascending: 'sorted ascending',
    sorted_descending: 'sorted descending',
    terms_of_service: 'Terms of Service',
    too_long: 'Too Long!',
    too_short: 'Too Short!',
    topic: 'Topic',
    topics: 'Topics',
    unable_to_logout: `Unable to logout!`,
    update_photo: 'Update photo',
    upload_photo: 'Upload photo',
    user: 'User',
    user_management: 'User Management',
    verify: 'Verify',
    verify_code_subtitle: 'Enter a 6 characters confirmation code that was shared with your group',
    verify_code_title: 'Please enter your group code',
    verify_email_and_code_illustration: 'verify email and code illustration',
    verify_email_subtitle_part_1: 'We have sent you a confirmation link to',
    verify_email_subtitle_part_2: 'please click that link to verify your email.',
    verify_email_title: 'Please check your email!',
    view_course: 'View course',
    view_lesson: 'View lesson',
    view_module: 'View module',
    your_account: 'Settings',
    lastest_lesson: 'Latest Lesson',
    all_lessons: 'All Lessons',
    open_lessons: 'open lessons',
    settings: 'settings',
    lecturer: 'Lecturer',
    language: 'language',
    language_preference: 'Language perference',
    language_preference_saved: 'Language preference updated successfully',
    language_required: 'Language preference is required',
    login_success: 'Logged in successfully',
    register_success: 'Registered successfully',
    user_update_success: 'User profile updated successfully',
    password_update_success: 'Password updated successfully',
    password_reset_success: 'Password reset successfully',
    password_reset_code_verified: 'Password reset code verified',
    'auth/email-already-in-use': 'The provided email is already in use by an existing user',
    'auth/expired-action-code': 'The link has expired',
    'auth/invalid-action-code': 'The link is tampered or was used before',
    'auth/invalid-email': 'The provided email is invalid',
    'auth/invalid-user-token': 'The user token is invalid',
    'auth/user-disabled': 'The user is disabled',
    'auth/user-not-found': 'The user is not found. If you are a new user, please register first',
    'auth/user-token-expired': 'The user token is expired',
    'auth/weak-password': 'Password is too weak',
    'auth/wrong-password': 'Incorrect credentials',
    'auth/invalid-group-code': 'Invalid group code',
    'db/no-document': 'No record(s) found',
    last_updated: 'Last Updated',
    by: 'by',
    phone_number_is_not_valid: 'Phone number is not valid',
    phone_number: 'Phone number',
    save: 'Save',
    fill_data: 'Fill the data bellow',
    inventory: 'Inventory',

    // Inventory-specific
    add_inventory: 'Add inventory',
    inventory_form: 'Inventory Form',
    edit_inventory: 'Edit inventory',
    person_name: 'Person name',
    computer_name: 'Computer name',
    serial_number: 'Serial number',
    company_label: 'Company',
    category_label: 'Category',
    returning_time: 'Returning time',
    issue_date: 'Issue date',
    now: 'Now',
    notes: 'Notes',
    loading: 'Loading...',
    sort_by: 'Sort by',
    created: 'Created',
    person: 'Person',
    item: 'Item',
    return_time: 'Return time',
    issued: 'Issued',
    return_action: 'Return',
    returning: 'Returning...',
    asc: 'Ascending',
    desc: 'Descending',
    delete_item_confirmation: 'Are you sure you want to delete this item?',
    delete: 'Delete',
    free: 'Free',
    search_name_or_item: 'Search name or item',

    // Personal
    scores: 'Scores',
    no_scores_yet: 'No scores yet',

    best_scores: 'Best scores',

    // Attendance
    view_attendance: 'View Attendance',
    attendance: 'Attendance',
    attendance_for_group: 'Attendance for',
    student_name: 'Student Name',
    total_hours: 'Total Hours',
    date: 'Date',
    start_date: 'Start date',
    end_date_required: 'End date is required',
    end_date: 'End date',
    lecture_cycle: 'Lecture cycle',
    monday_to_friday: 'Monday to Friday',
    monday_to_thursday: 'Monday to Thursday',
    custom_cycle: 'Custom days',
    lecture_days: 'Lecture days',
    lecture_days_required: 'Please select at least one lecture day',
    lecture_time_from: 'Lecture time from',
    lecture_time_to: 'Lecture time to',
    lecture_time_both_required: 'Please provide both lecture start and end time',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    load_students: 'Load students',
    refresh: 'Refresh',
    students_in_group: 'Students in group',
    add_student_to_group: 'Add student to group',
    add_student: 'Add student',
    group_created_successfully: 'Group created successfully',
    group_assigned_to_lecturer: 'Group assigned to lecturer successfully',
    group_assigned_to_curator: 'Group assigned to curator successfully',
    group_updated_successfully: 'Group updated successfully',
    student_added_successfully: 'Student added successfully',
    student_updated_successfully: 'Student updated successfully',
    student_deleted_successfully: 'Student deleted successfully',
    student_groups_updated: 'Student groups updated',
    no_groups_created: 'No groups created yet',
    no_users_found: 'No users found',
    group_end_before_start: 'The end date cannot be before the start date.',
    group_code_exists: 'A group with this code already exists. Please try creating it again.',
    group_invalid_lecture_time: 'Invalid lecture time. Use the HH:MM format.',
    group_invalid_lecture_cycle: 'Choose a lecture cycle.',
    group_invalid_date: 'Invalid date.',
    group_invalid_courses: 'The selected courses are invalid.',
    group_unknown_courses: 'Some selected courses no longer exist. Reload the page and choose the courses again.',
    group_not_found: 'Group not found. It may have been deleted: reload the page.',
    student_login_email: 'Sign-in email: {{email}}',
    student_email_in_group: 'A student with this email address is already in this group.',
    student_fields_required: 'Enter the student’s first name, last name and email address.',
    student_not_found: 'Student not found. They may have been deleted: reload the page.',
    start_date_required: 'Start date is required',
    students_list: 'Students list',
    hide_students: 'Hide students',
    edit_student: 'Edit student',
    delete_student_warning: 'This action permanently deletes the student.',
    delete_student_instruction: 'Type the current student email (or ID) to confirm deletion:',
    student_confirmation: 'Student confirmation',
    group_deleted_successfully: 'Group deleted successfully',
    delete_group_title: 'Delete group',
    delete_group_warning:
        'This permanently deletes the group. Student accounts are kept; they are only removed from this group.',
    delete_group_instruction: 'Type the group code to enable deletion:',
    group_code_confirmation: 'Group code confirmation',
    delete_group_confirm: 'Delete group permanently',
    group_details: 'Group details',
    subjects: 'Subjects',
    no_attendance_data: 'No attendance data available',
    error_fetching_attendance: 'Error fetching attendance data',
    loading_attendance: 'Loading attendance...',
    hours_abbreviation: 'h',
    export_to_excel: 'Download',
    total_days: 'Total Days',
    active_on_top: 'Active on top',
    ms_teams_created: 'Teams created',
    ms_teams_pending: 'Teams pending',
    ms_teams_failed: 'Teams failed',
    ms_teams_not_provisioned: 'No Teams group',
    create_ms_teams_group: 'Create Teams group',
    retry_ms_teams_creation: 'Convert to Team',
    ms_teams_provisioned_successfully: 'MS Teams group created successfully',
    ms_teams_provision_failed:
        'Failed to create MS Teams group. Please check that the server is running and try again.',
    ms_teams_conversion_failed: 'MS Teams group exists but could not be converted to a Team. Please try again later.',
    ms_teams_group_already_exists: 'An MS Teams group with this name already exists.',
    ms_teams_group_creation_failed: 'Failed to create MS Teams group.',
    assign: 'Assign',
    lecturer_assigned_and_notified: 'Lecturer assigned and notification email sent',
    curator_email_sent: 'Curator notification email sent',
    group_has_no_curator: 'The group has no curator.',
    lecturer_email_sent: 'Lecturer notification email sent',
    send: 'Send',
    send_email: 'Send email',
    send_onboarding_email: 'Send the welcome email',
    resend_onboarding_email: 'Send the welcome email again',
    onboarding_email_sent: 'Email sent',
    send_all_emails: 'Send emails',
    schedule_meeting: 'Schedule meeting',
    reschedule_meeting: 'Reschedule meeting',
    meeting_scheduled_successfully: 'Recurring lecture meeting scheduled',
    meeting_deleted_successfully: 'Recurring lecture meeting deleted',
    delete_meeting: 'Delete meeting',
    ms_teams_meeting_creation_failed: 'Failed to create recurring meeting.',
    ms_teams_meeting_deletion_failed: 'Could not delete the existing Teams meeting. Please try again later.',
    sync_team_members: 'Sync members',
    workflow_need_team_first: 'Create the Teams group first',
    workflow_need_lecturer_first: 'Assign a lecturer to the group first',
    workflow_need_ms_accounts: 'All students must have MS accounts before syncing',
    workflow_need_sync_first: 'Sync all members to the Team first',
    notify_lecturer_failed: 'Lecturer assigned, but failed to send notification email',
    lecturer_has_no_email: 'The lecturer or curator has no email address configured',
    loading_students: 'Loading students...',
    student_with_same_name_already_exists:
        'A student with the same first and last name already exists. Please use a different name or contact ' +
        'an administrator.',
    unsaved_changes_title: 'Unsaved changes',
    discard_changes: 'Discard',
    unsaved_changes_message: 'Group information has been changed but not saved. Save the changes or discard them.',
};

export default en;
